/**
 * Symbol for identifying injectables.
 * @internal
 */
export const INJECTABLE_SYMBOL = Symbol('injectable');
/**
 * @__NO_SIDE_EFFECTS__
 */
export function defineInjectable(optionsOrResolve) {
    if (typeof optionsOrResolve === 'function') {
        return {
            resolve: optionsOrResolve,
            [INJECTABLE_SYMBOL]: true,
        };
    }
    return {
        ...optionsOrResolve,
        [INJECTABLE_SYMBOL]: true,
    };
}
/**
 * Type guard to check if a value is an injectable.
 * @param value - The value to check
 * @returns True if the value is an injectable, false otherwise
 */
export function isInjectable(value) {
    if (value == null) {
        return false;
    }
    return value[INJECTABLE_SYMBOL] !== undefined;
}
//# sourceMappingURL=Injectable.js.map